import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { concatMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface TransactionLogData {
  data: any;
}

@Component({
  selector: 'app-transaction-log',
  templateUrl: './transaction-log.html',
  styleUrls: ['./transaction-log.scss'],
})
export class TransactionLog implements OnInit {
  confirmButtonColor: string = 'warn';

  dataSource: any[] = [];
  displayedColumns: string[] = [
    'id',
    'user',
    'placeOrder',
    'type',
    'statCode',
    'statName',
    'refundId',
    'createdOn',
  ];
  errorFlag: boolean = false;
  message: any = null;

  constructor(
    private httpClient: HttpClient,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<TransactionLog>,
    @Inject(MAT_DIALOG_DATA) public data: TransactionLogData
  ) {}

  ngOnInit() {
    this.dataSource = this.data.data;
    for (const result of this.dataSource) {
      try {
        result.parsedValue = JSON.parse(result?.parsedPayload);
      } catch (err) {}
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
